import { create } from "zustand";

interface User {
  username?: string;
  roles?: string[];
  givenName?: string;
  familyName?: string;
  sub?: string;
  token?: any;
}

type UserStore = {
  user: User | null;
  setUser: (user: User) => void;
};

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  setUser: (user: User) => set({ user }),
}));
